<div class="link-container">
  <!-- With Link and Tooltip -->
  <rad-tooltip
    *ngIf="hasLink && hasTooltip"
    #radTooltip
    [attr.tooltip-label]="tooltipText"
    [attr.tooltip-placement]="tooltipPosition"
    tooltip-append-to="body">
    <rad-link
      [attr.href]="linkUrl"
      [attr.target]="target"
      [attr.external]="isExternal ? 'true' : null"
      [appShadowStyle]="linkStyle">
      {{ linkText }}
    </rad-link>
  </rad-tooltip>

  <!-- With Link, No Tooltip -->
  <rad-link
    *ngIf="hasLink && !hasTooltip"
    [appShadowStyle]="linkStyle"
    [attr.href]="linkUrl"
    [attr.target]="target"
    [attr.external]="isExternal ? 'true' : null">
    {{ linkText }}
  </rad-link>

  <!-- No Link, With Tooltip -->
  <rad-tooltip
    *ngIf="!hasLink && hasTooltip"
    #radTooltip
    [attr.tooltip-label]="tooltipText"
    [attr.tooltip-placement]="tooltipPosition"
    tooltip-append-to="body">
    <div class="plain-text">
      {{ linkText }}
    </div>
  </rad-tooltip>

  <!-- No Link, No Tooltip -->
  <div
    *ngIf="!hasLink && !hasTooltip"
    class="plain-text">
    {{ linkText }}
  </div>
</div>
